import { render } from 'engine/index';
import { showToast, Toast } from 'engine/utils';
import { AlarmClock } from 'lucide-static';
import { invLerp } from 'shared/util';

export function Timer({
	timerFrom,
	timerTo,
	sendReminder = false,
	alwaysShowSeconds = false,
}: {
	timerFrom: number;
	timerTo: number;
	sendReminder?: boolean;
	alwaysShowSeconds?: boolean;
}) {
	let oneMinuteReminder = sendReminder && Date.now() < timerFrom + 60_000;
	let time = 0;
	const view: HTMLElement = (
		<div
			class="relative size-16 shrink-0 rounded-full border border-gray-200 shadow-inner"
			style="background:conic-gradient(#e2e8f0 0%, #e2e8f0 var(--t), #db2777 var(--t));"
		>
			<div
				progress
				class="absolute inset-2 flex shrink-0 items-center justify-center rounded-full border border-gray-200 bg-gray-50 text-theme-700 shadow-sm"
			>
				{time}
			</div>
		</div>
	);

	const progress = view.querySelector('[progress]') as HTMLElement;

	const update = () => {
		const curTime = Date.now();
		const progressT = invLerp(curTime, timerFrom, timerTo);
		const remaining = (timerTo - curTime) / 1000;
		time = Math.max(remaining, 0);

		const total = Math.max(0, Math.ceil(time));

		const mins = Math.floor(total / 60);
		const secs = total % 60;

		const ss = mins ? String(secs).padStart(2, '0') : String(secs);

		const label =
			!alwaysShowSeconds && time > 60 ? (
				<span class="block text-center leading-none">
					{Math.ceil(time / 60)}
					<span class="block text-[10px] leading-none">min</span>
				</span>
			) : (
				<span>{mins ? `${mins}:${ss}` : ss}</span>
			);

		if (oneMinuteReminder && curTime >= timerFrom + 60_000) {
			oneMinuteReminder = false;
			showToast(<Toast icon={AlarmClock} title="1e minuut is voorbij!" />, 3000);
		}

		render(progress, label);

		view.style.setProperty('--t', progressT * 100 + '%');

		if (time > 0) requestAnimationFrame(update);
	};

	requestAnimationFrame((_t) => {
		requestAnimationFrame(update);
	});

	return view;
}
